import React from 'react';
import {
  workloadItemChipClassName
} from './Styles';

interface ComputeItemProps {
  chip: string;
  title: string;
  price: string;
  priceUnit?: string;
  interestHref?: string;
  showChipInHeader?: boolean;
}

export default function ComputeItem({
  chip,
  title,
  price,
  priceUnit = ' / hour',
  showChipInHeader = false
}: ComputeItemProps) {

  return (
    <div className="flex flex-col items-center px-3xl pt-3xl pb-7xl !gap-s !w-[245px]">
      {!showChipInHeader && <span className={workloadItemChipClassName}>{chip}</span>}
      <span className="font-semibold text-primary text-5xl leading-18xl">{title}</span>
      <span className="font-semibold text-cic-blue-500 text-2xl leading-4xl">
        {price}
        <span className="font-medium text-xl leading-3xl">{priceUnit}</span>
      </span>
 
    </div>
  );
}